<template>
  <unicom-linha :espacamento="false">
    <unicom-coluna sm="12" style="padding-bottom: 24px">
      <div class="titulo negrito cor-fonte fonte-primaria">
        Solicitação: <span class="cor-principal"> Anexos </span>
      </div>
      <div class="medio segunda-cor-fonte" style="padding-top: 12px">
        Solicitação de anexo. Para concluir, anexe o(s) arquivo(s) do tipo
        (.zip, .rar, .7z, .pdf, .png, .jpg, .jpeg).
      </div>
    </unicom-coluna>
    <unicom-coluna sm="12" :md="12" style="padding-right: 32px">
      <transition name="importador">
        <Importador
          class="importador"
          v-if="mostrarImportador"
          @arquivo="salvarArquivo"
        />
      </transition>
    </unicom-coluna>
    <unicom-coluna
      class="lista-arquivos"
      :class="{ aberto: mostrarImportador }"
      sm="12"
      :md="12"
    >
      <ArquivoRecebido
        v-if="mostrarArquivoRecebido"
        :informacoesArquivo="listaArquivos"
        @reprovar-arquivo="deleteArquivo"
        @arquivo-para-descricao="carregarArquivoParaDescricao"
        @baixar-arquivo="uuid => $emit('baixar-arquivo', uuid)"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import ArquivoRecebido from "./componentes/ArquivoRecebido/ArquivoRecebido";
import Importador from "../Singular/Importador/ImportadorAnexos.vue";
import { TIPOS_ARQUIVOS } from "../ListaArquivos/TiposArquivos/TiposArquivosEnum";
import AnalistaMixin from "./AnalistaMixin";
export default {
  mixins: [AnalistaMixin],
  components: {
    Importador,
    ArquivoRecebido
  },
  props: {
    listaArquivos: {
      type: Array,
      default: () => {
        return [];
      }
    },
    codigoUnimed: {
      type: [String, Number]
    },
    podeEnviarArquivo: {
      type: Boolean
    }
  },
  computed: {
    mostrarArquivoRecebido() {
      return this.listaArquivos.some(e => {
        return e.tipoArquivo === TIPOS_ARQUIVOS.ANALISE;
      });
    },
    mostrarImportador() {
      if (this.podeEnviarArquivo) return true;
      return false;
    }
  }
};
</script>
